/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import applyTreeSelectionCommitToState from './helpers/applyTreeSelectionCommitToState';
import createTreeSelectionThunk from './helpers/createTreeSelectionThunk';
import { getRangeAddEntries } from './helpers/treeSelection';
import { MASTER_SELECTION_CONTEXT } from './helpers/selectionContext';

export const selectTreeRangeCommit = createAction('products/selectTreeRange/commit');

export const selectTreeRange = createTreeSelectionThunk(
  'products/selectTreeRange',
  selectTreeRangeCommit,
);

export const reducer = (builder) => {
  builder.addCase(selectTreeRangeCommit, (state, { payload }) => {
    const { rangeNodes, lastClickedKey, keepChannelSelection } = payload;
    const addEntries = getRangeAddEntries(rangeNodes);

    applyTreeSelectionCommitToState(state, {
      addEntries,
      context: MASTER_SELECTION_CONTEXT,
      lastClickedKey,
      keepChannelSelection,
      source: 'tree',
    });
  });
};
